import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { ITenant } from "../../AbmLocalPage/types";

// this hash made from "0lugares2017"
export const getAllRubros = async (tenant: ITenant) =>
  axiosInstanceMain.get(
    `/${tenant.path}/rubros?deviceId=0&clave=347ebc28653419c788302d8eba55b75a`
  );
export const getAllFeatures = async (tenant: ITenant) =>
  await axiosInstanceMain.get(`/${tenant.path}/locales/caracteristicas`);
